import type { GoalCollectionResponseModel } from "@/features/collections/api/useGoalCollection";
import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import { useQueryClient, type MutationFunction } from "@tanstack/react-query";

export interface SetGoalCollectionRequestModel {
	readonly goalCollectionId: string | null;
}

export interface SetGoalCollectionRequestProperties {
	readonly collectionId: string;
	readonly requestModel: SetGoalCollectionRequestModel;
}

export const useSetGoalCollection = () => {
	const http = useHTTP("Required");
	const queryClient = useQueryClient();

	const mutationFn: MutationFunction<HTTPResponse<GoalCollectionResponseModel>, SetGoalCollectionRequestProperties> = requestProperties => {
		return http<GoalCollectionResponseModel, SetGoalCollectionRequestModel>({
			method: "PUT",
			url: `/collection/${requestProperties.collectionId}/goal-collection`,
			body: requestProperties.requestModel
		});
	};

	return useHTTPMutation({
		mutationFn,
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["goalCollection"] });
			queryClient.invalidateQueries({ queryKey: ["collection"] });
			queryClient.invalidateQueries({ queryKey: ["collections"] });
			queryClient.invalidateQueries({ queryKey: ["collectionProgress"] });
			queryClient.invalidateQueries({ queryKey: ["progressSummaries"] });
		}
	});
};
